import { fetchOfferStats } from 'actions/RecommendationActions'
import GeoContext from 'contexts/geoContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useContext, useEffect } from 'react'
import { getOfferValue } from 'selectors/recomendations/offerStatsSelectors'

// $5 revenue per view
const LOW_RPV_THRESHOLD = 5

/**
 * trigger recommendations (LERE) if the RPV is below some threshold.
 *
 * The offerValue is fetch from LERE BE API
 */
export function useLowRpvLere(offerId: string, canUseLere: boolean = true) {
  const dispatch = useAppDispatch()
  const { currentRegionCode } = useContext(GeoContext)

  useEffect(() => {
    if (canUseLere) {
      dispatch(fetchOfferStats(offerId, currentRegionCode))
    }
  }, [dispatch, offerId, currentRegionCode, canUseLere])

  const offerValue = useAppSelector(state => getOfferValue(state, offerId))

  const shouldTriggerLere = canUseLere && Number.isFinite(offerValue) && (offerValue! < LOW_RPV_THRESHOLD)

  return shouldTriggerLere
}
